<template>
    <div style="height: 100%">
        <RelatorioLpsNaoVisitaList v-show="!rotaAninhada" :reloadData="reloadData" />
        <router-view />
    </div>
</template>

<script>
import RelatorioLpsNaoVisitaList from '@/components/promotor/relatorio-analitico/relatorio-lps-nao-visita/RelatorioLpsNaoVisitaList.vue';


export default {
    name: 'RelatorioLpsNaoVisitaListRoute',

    beforeRouteUpdate(to, from, next) {
        this.rotaAninhada = to.name != 'relatorio-lps-nao-visita-list';
        if (from.name != 'relatorio-lps-nao-visita-list' && to.name == 'relatorio-lps-nao-visita-list') {
            this.reloadData = true;
            setTimeout(() => (this.reloadData = false), 300);
        }
        next();
    },
    components: {
        RelatorioLpsNaoVisitaList,
    },
    data() {
        return {
            rotaAninhada: false,
            reloadData: false,
        };
    },
    created() {
        this.rotaAninhada =
            this.$route.name.includes('relatorio-lps-nao-visita') &&
            this.$route.name != 'relatorio-lps-nao-visita-list';
    },
};
</script>
